import { motion } from "framer-motion";

/**
 * Banded header used on legal / narrative pages.
 * Matches SPEC §5.4 ThemedLegalPage layout.
 */
export default function BandedHeader({ eyebrow, title, subtitle, effective }) {
  return (
    <section
      className="relative pt-[130px] md:pt-[150px] pb-16 md:pb-24 text-white overflow-hidden"
      style={{ background: "var(--surface-inverse)" }}
    >
      <div className="wrap relative z-10 grid md:grid-cols-3 gap-6 items-center">
        <div className="md:col-span-2">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-extrabold tracking-[0.16em] uppercase mb-6 backdrop-blur-md"
            style={{
              background: "rgba(255,255,255,0.14)",
              color: "#FCD34D",
              border: "1px solid rgba(255,255,255,0.15)",
            }}
          >
            {eyebrow}
          </motion.div>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-[30px] md:text-[44px] font-extrabold leading-[1.1] max-w-3xl"
          >
            {title}
          </motion.h1>
          {subtitle && (
            <motion.p
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="mt-4 text-white/80 max-w-2xl text-base md:text-lg leading-relaxed"
            >
              {subtitle}
            </motion.p>
          )}
          {effective && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="mt-5 inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold"
              style={{ background: "var(--card)", color: "var(--on-surface)" }}
            >
              Effective {effective}
            </motion.div>
          )}
        </div>
        <div className="hidden md:flex md:justify-end">
          <motion.img
            src="/assets/brand/logo.png"
            alt=""
            className="w-[220px] h-[220px] object-contain drop-shadow-2xl"
            initial={{ opacity: 0, scale: 0.85 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            aria-hidden
          />
        </div>
      </div>
    </section>
  );
}
